export const stepsSinglePlan = {
    "pagamento": {
      "previous": null,
      "next": "sucesso",
      "index": 0
    },
    "sucesso": {
      "previous": "pagamento",
      "next": null,
      "index": 1
    }
  };
